import {NgModule} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';


@NgModule({
  imports: [ ],
  exports: [
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    MatProgressSpinnerModule,

    // TODO: no futuro se não usarmos nada desse modulo, remover,
    // hoje é usado apenas para exibir icones
    MatButtonModule
  ]
})
export class MaterialModule { }
